import StantMultiselect from "../../utils/stant_multiselect.coffee"

$(document).on 'turbolinks:load', ->
  new StantMultiselect('construction-status-multiselect').add_listener()